module.exports = __webpack_public_path__ + "05778a79.svg";